import React, { HTMLAttributes } from 'react';

export const TextInput = React.forwardRef<
  HTMLInputElement,
  {
    type?: string;
    placeholder?: string;
    value?: string;
    maxLength?: number;
    inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
    autoFocus?: boolean;
    onChange?: (value: string) => void;
  }
>(
  (
    { type, placeholder, value, maxLength, inputMode, autoFocus, onChange },
    ref,
  ) => (
    <input
      ref={ref}
      type={type ?? 'text'}
      className="block appearance-none w-full border border-gray-400 text-gray-700 py-3 px-3 rounded leading-tight focus:outline-none focus:border-blue-400"
      placeholder={placeholder}
      value={value || ''}
      onChange={(e) => {
        onChange?.(e.target.value);
      }}
      maxLength={maxLength}
      inputMode={inputMode}
      autoFocus={autoFocus}
    />
  ),
);
TextInput.displayName = 'TextInput';

export const TextArea = React.forwardRef<
  HTMLTextAreaElement,
  {
    placeholder?: string;
    value?: string;
    maxLength?: number;
    inputMode?: HTMLAttributes<HTMLInputElement>['inputMode'];
    autoFocus?: boolean;
    onChange?: (value: string) => void;
  }
>(({ placeholder, value, maxLength, inputMode, autoFocus, onChange }, ref) => (
  <textarea
    ref={ref}
    className="block appearance-none w-full border border-gray-400 text-gray-700 py-3 px-3 rounded leading-tight focus:outline-none focus:border-blue-400 h-28"
    placeholder={placeholder}
    value={value || ''}
    onChange={(e) => {
      onChange?.(e.target.value);
    }}
    maxLength={maxLength}
    inputMode={inputMode}
    autoFocus={autoFocus}
  />
));
TextArea.displayName = 'TextArea';
